// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.database-model-content-tIj0m7 .semi-form-field{padding-top:0;padding-bottom:16px}.database-model-content-tIj0m7 .semi-input-wrapper{background-color:rgba(var(--coze-bg-2),var(--coze-bg-2-alpha))}.database-model-content-tIj0m7 .semi-input-textarea-wrapper{background-color:rgba(var(--coze-bg-2),var(--coze-bg-2-alpha))}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"database-model-content": `database-model-content-tIj0m7`,
	"databaseModelContent": `database-model-content-tIj0m7`
};
export default ___CSS_LOADER_EXPORT___;
